import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'
import {DatabaseMetadata} from 'graphql-api'

import {Link, Tooltip} from '@mdsol/onex-design'

const RaveUrl: FC<CellPropsType> = ({cell}) => {
  const hostname = cell.getValue()
  const {original, index} = cell.row
  const {databaseId, raveUrl} = original as DatabaseMetadata

  return hostname.length
    ? <Tooltip
      id={`tooltip-raveUrl-database-${index}`}
      dataTestId='database-raveUrl-tooltip'
      placement='bottom-start'
      tooltipChildren={databaseId}
    >
      <Link href={raveUrl} dataTestId='database-raveUrl-link' targetBlank>{hostname}</Link>
    </Tooltip>
    : null
}

export default RaveUrl
